import React from 'react'
import { Link, graphql } from 'gatsby'
import Img from 'gatsby-image'

import Layout from '../components/layout'

class GalleryIndex extends React.Component {
  render() {
    return (
      <Layout location={this.props.location}>
        <div style={{display: "flex", flexWrap: "wrap", alignItems: "center"}}>
        {this.props.data.photos.edges.map(({ node: { name, fields: { slug }, childImageSharp: {fluid} } }) => {
          return (
            <Link key={slug} style={{ boxShadow: 'none', width: "33%", paddingTop: "33%", position: "relative" }} to={slug}>
              <div style={{position: "absolute", top: 0, left: 0, width: "100%", height: "100%"}}>
              <Img fluid={fluid} style={{position: "absolute", top: 0, left: 0, right: 0, bottom: 0}} imgStyle={{objectFit: "contain"}}/>
              </div>
            </Link>
          )
        })}
        </div>
      </Layout>
    )
  }
}

export default GalleryIndex

export const pageQuery = graphql`
  query {
    photos: allFile(filter: { sourceInstanceName: { eq: "photos" } }) {
      edges {
        node {
          name
          absolutePath
          fields {
            slug
          }
          childImageSharp {
            fluid(maxWidth: 640) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
